import { createPartners, updatePartners } from 'api/partners';
import {
  debounceCity,
  debouncePartnerTypes,
  debounceProject,
  debounceRegional,
  debounceState,
  debounceViaCep,
} from 'utils/debounces';

import type { FormType } from '..';

export const partnerForm: FormType = {
  createFn: createPartners,

  updateFn: updatePartners,
  cancelText: 'Cancelar',
  submitText: 'Salvar Parceiro',
  successText: 'Parceiro salvo com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Nome da empresa',
          label: 'Nome',
        },
      },
    ],
    [
      {
        name: 'type',
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Tipo',
          loadOptions: debouncePartnerTypes,
        },
      },
    ],
    [
      {
        name: 'regional',
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Regional',
          loadOptions: debounceRegional,
        },
      },
      {
        name: 'code',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Ex: Lab01',
          label: 'Código (opcional)',
        },
      },
    ],
    [

      {
        name: 'email',
        type: 'text',
        required: true,
        props: {
          placeholder: 'nome@email.com',
          label: 'Email',
        },
      },
      {
        name: 'localPhone',
        type: 'text',
        required: false,
        mask: 'maskLocalPhone',
        props: {
          placeholder: '(00) 9 8765-4321',
          label: 'Telefone',
        },
      },
    ],
    [
      {
        name: 'documentNumber',
        type: 'text',
        required: true,
        mask: 'maskCnpj',
        props: {
          placeholder: 'CNPJ',
          label: 'CNPJ',
        },
      },
      {
        name: 'phone',
        type: 'text',
        required: false,
        mask: 'maskPhone',
        props: {
          placeholder: '(00) 9 8765-4321',
          label: 'Celular',
        },
      },
    ],
    [
      {
        name: 'corporateName',
        type: 'text',
        required: true,
        props: {
          viewProps: {
            width: '50%',
          },
          placeholder: 'Razão social',
          label: 'Razão Social',
        },
      },
      {
        name: 'workingHours.0',
        type: 'text',
        required: false,
        mask: 'maskTime',
        props: {
          viewProps: {
            width: '25%',
          },
          placeholder: '00:00',
          label: 'Horário (opcional)',
        },
      },
      {
        name: 'workingHours.1',
        type: 'text',
        required: false,
        mask: 'maskTime',
        props: {
          viewProps: {
            width: '25%',
          },
          placeholder: '00:00',
          mt: 5,
        },
      },
    ],
    [{
      name: 'contact',
      type: 'text',
      required: true,
      props: {
        placeholder: 'Nome do contato',
        label: 'Contato',
      },
    }, {
      name: 'project',
      type: 'select',
      required: false,
      props: {
        placeholder: 'Buscar',
        label: 'Projeto',
        loadOptions: debounceProject,
      },
    }],
    [],
    [
      {
        name: 'accountable',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Responsável técnico',
          label: 'Responsável técnico',
        },
      },
      {
        name: 'accountableDocumentNumber',
        type: 'text',
        required: false,
        props: {
          placeholder: 'RG ou CPF',
          label: 'Documento do responsável técnico',
        },
      },
    ],
    [
      {
        name: 'accountableSignatureUrl',
        type: 'image',
        required: false,
        props: {
          label: 'Foto da assinatura do responsável técnico',
        },
      },
    ],
    [],
    [
      {
        name: 'address.postalCode',
        type: 'text',
        required: true,
        onChange: (event, setValue) => {
          const handleAddress = (data) => {
            setValue('address.street', data.logradouro);
            setValue('address.district', data.bairro);
            setValue('address.city', {
              label: data.localidade,
              name: data.localidade,
            });
            setValue('address.state', {
              label: data.uf,
              name: data.uf,
            });
          };
          debounceViaCep(event.target.value, handleAddress);
        },
        props: {
          viewProps: {
            width: '49%',
          },
          placeholder: '000000-000',
          label: 'CEP',
        },
      },
    ],
    [
      {
        name: 'address.street',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ex: Rua Eduardo Menezes',
          label: 'Endereço',
        },
      },
      {
        name: 'address.number',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ex: 000 A',
          label: 'Número',
        },
      },
    ],
    [
      {
        name: 'address.complement',
        type: 'text',
        required: false,
        props: {
          placeholder: 'Ex: Bloco 3',
          label: 'Complemento',
        },
      },
      {
        name: 'address.district',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Ex: São Mateus',
          label: 'Bairro',
        },
      },
    ],
    [
      {
        name: 'address.city',
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Cidade',
          loadOptions: debounceCity,
        },
      },
      {
        name: 'address.state',
        type: 'select',
        required: true,
        props: {
          placeholder: 'Buscar',
          label: 'Estado',
          loadOptions: debounceState,
        },
      },
    ],
  ],
};
